import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PtPermissions, PtUiAppRoutes } from '@pt/pt-models';
import { PtCoreActions, PtCoreSelectors } from '@pt/pt-core';
import { PrimatooModule } from 'it/primatoo/openapi/api/org/schemas/common/PrimatooModule';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceGuardService {
  constructor(private store: Store) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(PtCoreSelectors.activeModulesAndPermission),
      map((r: {
        activeModules: PrimatooModule[],
        activePermissions: PtPermissions[]
      }) => {
        return true;

        // if (r.activePermissions?.includes(PtPermissions.MANAGE_WORKSPACE)) {
        //   return true;
        // } else {
        //   this.store.dispatch(PtCoreActions.navigateTo({
        //     route: [PtUiAppRoutes.FORBIDDEN_MODULE],
        //     queryParams: {
        //       m: 'WORKSPACE'
        //     }
        //   }));
        //   return false;
        // }
      })
    );
  }
}
